// The tab bar and every route in the app.
//
// Owned by the navigation shell (bottom-tabs) and rewritten by `spec apply` —
// so commit before running one. Everything below is otherwise mine.
//
// FOUR TABS, and that is deliberate: SHELL.md says five is the ceiling before
// a bottom bar should become a sidebar. The six picker modes are NOT tabs. A
// tab bar is for destinations, and a mode is something you start, so they are
// pushed from Play and keep the bar and a back button.

import { createRouter, createMemoryHistory } from '@ionic/vue-router';
import {
  gameControllerOutline,
  flameOutline,
  todayOutline,
  trophyOutline,
} from 'ionicons/icons';

import TabsShell from './pages/TabsShell.vue';
import { PRODUCT_ROUTES, HOME_ROUTE } from './product-routes.js';

/** Where the app opens: the mode picker. */
export const HOME = HOME_ROUTE;

// Icons are IMPORTED, never `<ion-icon name="...">`. The string form fetches
// its SVG from a CDN at runtime, which this app's CSP blocks and an offline
// app could not reach anyway — an invisible tab bar that works on your machine
// and is blank on a plane.
export const TABS = [
  { name: 'play', label: 'Play', path: '/tabs/play', icon: gameControllerOutline },
  { name: 'endurance', label: 'Endurance', path: '/tabs/endurance', icon: flameOutline },
  { name: 'daily', label: 'Daily', path: '/tabs/daily', icon: todayOutline },
  { name: 'trophies', label: 'Trophies', path: '/tabs/trophies', icon: trophyOutline },
];

export default createRouter({
  history: createMemoryHistory(),
  routes: [
    { path: '/', redirect: HOME },
    {
      path: '/tabs/',
      component: TabsShell,
      children: [
        { path: '', redirect: HOME },
        ...PRODUCT_ROUTES.map((r) => ({
          path: r.path.replace(/^\/tabs\//, ''),
          name: r.id,
          component: r.component,
          props: true,
        })),
      ],
    },

    // A LINK THAT MISSES STILL HAS TO LAND SOMEWHERE.
    //
    // Without this, anything the table does not know — `/tabs/played`, a
    // Universal Link written before a screen was renamed, a path the deep-link
    // handler pushes that no longer exists — matches no record at all, and
    // vue-router renders the outlet EMPTY. Not a not-found screen: a blank
    // white page under a tab bar, with a warning in a console nobody is
    // reading. Home is the honest answer to a link that has gone stale.
    { path: '/:pathMatch(.*)*', redirect: HOME },
  ],
});
